import { SearchOutlined, CloseOutlined,SisternodeOutlined,CheckCircleOutlined,CalendarOutlined, StopOutlined } from '@ant-design/icons';
import { Tag, Button, Modal, Input, message } from 'antd';
import { NdoeImage, NdoeResponsiveTable } from '../../components/ndoe';
import React, { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { useSelector } from 'react-redux';
import config from '../../config';
import { format } from 'date-fns';
import ReceptionSelect from './ReceptionSelect';

const ReceptionOne = ({dateId}) => {
    const DOMAIN = config.REACT_APP_SERVER_DOMAIN;
    const [getRapport, setGetRapport] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchValue, setSearchValue] = useState('');
    // Somme réelle des largeurs de colonnes ci-dessous. Sous cette valeur la
    // table DÉFILE au lieu de comprimer — c'est ce qui rognait « Annuler » et
    // coupait « TYPE DE MOUVEME/NT » dans la modale (signalé le 31/07/2026).
    const scroll = { x: 1280 };
    const [open, setOpen] = useState(false);
    // Annulation dédiée d'une réception (admin uniquement).
    const user = useSelector((state) => state.user.currentUser);
    const isAdmin = user?.role === 'admin';
    const token = user?.accessToken || user?.token || '';
    const [cancelTarget, setCancelTarget] = useState(null);
    const [cancelMotif, setCancelMotif] = useState('');
    const [cancelling, setCancelling] = useState(false);




const columns = [
    { title: '#', dataIndex: 'id', key: 'id', width: 56, render: (text, record, index) => index + 1 },
     {
      title: 'image',
      width: 88,
      dataIndex: 'img',
      key: 'img',
      render: (text, record) => (
        <NdoeImage src={record.img} alt={record.nom_produit || record.produit || 'Article'} size="lg" />
      ),
    },
    {
        title: 'Marque',
        width: 116,
        dataIndex: 'nom_marque',
        key: 'nom_marque',
        render: (nom_marque) => (
          <Tag color={'blue'}>{nom_marque}</Tag>
        ),
    },
    {
        title: 'Categorie',
        width: 160,
        dataIndex: 'nom_categorie',
        key: 'categorie',
        render: (categorie) => (
          <Tag color={'blue'}>{categorie}</Tag>
        ),
    },
    {
        title: 'Couleur',
        width: 132,
        dataIndex: 'description',
        key: 'description',
        render: (color) => {
          let tagColor;
      
          if (color === 'Rouge') {
            tagColor = 'red';
          } else if (color === 'Noir') {
            tagColor = 'black';
          } else if (color === 'Orange') {
            tagColor = 'orange';
          } else if (color === 'Bleu') {
            tagColor = 'skyblue';
          } else if (color === 'Chocolat') {
            tagColor = 'chocolate';
          } else if (color === 'Vert fluo') {
            tagColor = 'lime';
          } else if (color === 'Rose fuchsia') {
            tagColor = 'hotpink';
          } else if (color === 'Beige saumon') {
            tagColor = 'burlywood';
          }
      
          return (
            <Tag color={tagColor}>{color}</Tag>
          );
        },
      },
      {
        title: 'Taille',
        width: 84,
        dataIndex: 'taille',
        key: 'taille',
        sorter: (a, b) => a.taille - b.taille,
        sortDirections: ['descend', 'ascend'],
        render: (taille) => (
          <Tag color={'blue'}>{taille}</Tag>
        ),
    },
    {
      title: 'Date de réception',
      width: 148,
      dataIndex: 'date_reception',
      key: 'date_reception',
      sorter: (a, b) => a.date_reception - b.date_reception,
      sortDirections: ['descend', 'ascend'],
      render: (text) => (
        <Tag color="blue" icon={<CalendarOutlined />}>
          {format(new Date(text), 'dd-MM-yyyy')}
        </Tag>
      ),
    },
    {
      title: 'Type de mouvement',
      width: 156,
      dataIndex: 'type_mouvement',
      key: 'type_mouvement',
      render: (type_mouvement) => (
        <Tag color={'green'} icon={<CheckCircleOutlined />}>
          {type_mouvement}
        </Tag>
      ),
    },
    {
        title: 'Qté reçue',
        width: 104,
        dataIndex: 'Qte_recu',
        key: 'Qte_recu',
        sorter: (a, b) => a.Qte_recu - b.Qte_recu,
        render: (Qte_recu) => (
          <Tag color={Qte_recu > 0 ? 'green' : 'red'}>{Qte_recu}</Tag>
        ),
      },
      {
        title: 'Qté en stock',
        width: 116,
        dataIndex: 'quantite_stock',
        key: 'quantite_stock',
        sorter: (a, b) => a.quantite_stock - b.quantite_stock,
        render: (quantite_stock) => (
          <Tag color={quantite_stock > 0 ? 'green' : 'red'}>{quantite_stock}</Tag>
        ),
      },
      {
        title: 'Action',
        key: 'action',
        width: 120,
        render: (text, record) => (
          Number(record.annule) === 1
            ? <Tag color="red" icon={<StopOutlined />}>Annulée</Tag>
            : (isAdmin
                ? <Button danger size="small" icon={<StopOutlined />} onClick={() => { setCancelTarget(record); setCancelMotif(''); }}>Annuler</Button>
                : null)
        ),
      }
];

const HandOpen = () =>{
  setOpen(!open)
}

const fetchData = useCallback(async () => {
  try {
    setLoading(true);
    const { data } = await axios.get(`${DOMAIN}/api/produit/receptionOne?dateId=${dateId}`);
    setGetRapport(data);
  } catch (error) {
    console.log(error);
  } finally {
    setLoading(false);
  }
}, [DOMAIN, dateId]);

useEffect(() => { fetchData(); }, [fetchData]);

// Annule la réception ciblée (contre-passation stock côté serveur) puis rafraîchit.
const doCancel = async () => {
  if (!cancelTarget) return;
  setCancelling(true);
  try {
    await axios.put(
      `${DOMAIN}/api/produit/reception/${cancelTarget.id_reception}/annuler`,
      { motif: cancelMotif || undefined },
      { headers: { Authorization: `Bearer ${token}` } },
    );
    message.success('Réception annulée : stock repris.');
    setCancelTarget(null);
    setCancelMotif('');
    await fetchData();
  } catch (err) {
    message.error(err?.response?.data?.error || 'Annulation impossible.');
  } finally {
    setCancelling(false);
  }
};

 const filteredData = getRapport?.filter((item) =>
  item.nom_marque?.toLowerCase().includes(searchValue.toLowerCase()) ||
  item.nom_categorie?.toLowerCase().includes(searchValue.toLowerCase()) ||
  item.description?.toLowerCase().includes(searchValue.toLowerCase())

)

  return (
    <>
        <div className="products">
            <div className="product-container">
                    <div className="product-bottom">
                      <div className="product-bottom-top">
                          <div className="product-bottom-left">
                              <div className="product-row-search">
                                  <SearchOutlined className='product-icon-plus'/>
                                  <input type="search" name="" value={searchValue} onChange={(e) => setSearchValue(e.target.value)} placeholder='Recherche...' className='product-search' />
                              </div>
                          </div>
                          <div className="product-bottom-right">
                          </div>
                      </div>
{/*                        {open &&
                              <ReceptionSelect getProduits={setGetRapport}/> } */}
                      <div className="rowChart-row-table">
                          <NdoeResponsiveTable columns={columns} data={filteredData} loading={loading} scroll={scroll} pagination={{ pageSize: 10}} />
                      </div>
                    </div>
            </div>
        </div>

        <Modal
          title="Annuler la réception"
          open={!!cancelTarget}
          onOk={doCancel}
          onCancel={() => setCancelTarget(null)}
          okText="Confirmer l'annulation"
          cancelText="Fermer"
          okButtonProps={{ danger: true, loading: cancelling }}
        >
          {cancelTarget && <>
            <p>Réception de <b>{cancelTarget.Qte_recu}</b> paire(s) — {cancelTarget.nom_marque} {cancelTarget.nom_categorie} · P{cancelTarget.taille} · {cancelTarget.description}.</p>
            <p style={{ color: '#8a5a10' }}>Le stock sera repris de <b>{cancelTarget.Qte_recu}</b> unité(s). L'opération est refusée si une partie a déjà été vendue/sortie.</p>
            <Input.TextArea rows={2} placeholder="Motif (optionnel) — ex : double saisie, erreur de quantité" value={cancelMotif} onChange={(e) => setCancelMotif(e.target.value)} maxLength={200} />
          </>}
        </Modal>

    </>
  )
}

export default ReceptionOne